import React, { type FC, type PropsWithChildren, type ReactNode } from "react";
import { Card, cn } from "@heroui/react";
import { Link } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";

import { AppRoutes } from "@domain/routing/routeConstants";

interface Props {
    title?: ReactNode;
    width?: number;
    cardClassName?: string;
}

export const AuthLayout: FC<PropsWithChildren<Props>> = ({ title, children, width, cardClassName }) => {
    return (
        <div className="absolute w-full min-h-[calc(100%-52px)] pb-5">
            <div className="absolute inset-0 bg-[url('../../assets/507364256--optimized.jpg')] bg-center bg-cover bg-no-repeat blur-xl" />
            <div className={cn("absolute left-1/2 -translate-x-1/2", cardClassName, "mt-8")}>
                <Card className={width ? `w-[${width}px]` : "w-[500px]"}>
                    {title && <Card.Header className="font-bold text-lg">{title}</Card.Header>}
                    <Card.Content className="p-2">{children}</Card.Content>
                </Card>
            </div>
            <div className="fixed right-0 bottom-0 pr-5 text-sm flex gap-2">
                <Link to={AppRoutes.impressum}>
                    <FormattedMessage id="app.page.legal.impressum" />
                </Link>
                <Link to={AppRoutes.haftungsausschluss}>
                    <FormattedMessage id="app.page.legal.haftungsausschluss" />
                </Link>
                <Link to={AppRoutes.agb}>
                    <FormattedMessage id="app.page.legal.agb" />
                </Link>
                <Link to={AppRoutes.datenschutz}>
                    <FormattedMessage id="app.page.legal.datenschutz" />
                </Link>
                <Link to={AppRoutes.cookies}>
                    <FormattedMessage id="app.page.legal.cookiePolicy" />
                </Link>
            </div>
        </div>
    );
};
